
import React from "react";

const StarIcon: React.FC<{ className?: string; size?: number }> = ({ className = "", size = 40 }) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="19.4444" fill="white" stroke="#EDEBEC" strokeWidth="1.11111" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1043 12.177L22.9317 15.8278C23.1108 16.1862 23.4565 16.4347 23.8573 16.4922L27.9453 17.0806C28.9554 17.2264 29.3573 18.4505 28.6263 19.1519L25.6702 21.9924C25.3797 22.2718 25.2474 22.6733 25.3162 23.0676L26.0138 27.0778C26.1856 28.0698 25.1298 28.8267 24.227 28.3574L20.5732 26.4627C20.215 26.2768 19.786 26.2768 19.4268 26.4627L15.773 28.3574C14.8702 28.8267 13.8144 28.0698 13.9872 27.0778L14.6838 23.0676C14.7526 22.6733 14.6203 22.2718 14.3298 21.9924L11.3737 19.1519C10.6427 18.4505 11.0446 17.2264 12.0547 17.0806L16.1427 16.4922C16.5435 16.4347 16.8903 16.1862 17.0694 15.8278L18.8957 12.177C19.3477 11.2743 20.6523 11.2743 21.1043 12.177Z"
        stroke="#0069AD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13 12L14.8 14.4" stroke="#00A7E4" strokeLinecap="round" />
      <path d="M26.8 12L25 14.4" stroke="#00A7E4" strokeLinecap="round" />
    </svg>
  );
};

export default StarIcon;